import messagesEs from './es.json';
import messagesEn from './en.json';

const messages = {
  es: messagesEs,
  en: messagesEn,
};

/*
    Define user's language. Different browsers have the user locale defined
    on different fields on the `navigator` object, so we make sure to account
    for these different by checking all of them
*/
const language = (navigator.languages && navigator.languages[0])
  || navigator.language
  || navigator.userLanguage
  || 'en';

const getMessages = () => {
  const languageOnly = language.toLowerCase().split(/[_-]+/)[0];
  return {
    language,
    messages,
    language_only: languageOnly,
  };
};

export { getMessages as default };
